import { FormArray } from '@angular/forms';
import { extendMoment } from 'moment-range';
import * as moment from 'moment';
export * from './validators';

export function DrowpdownFilterHandler(datasetProp, filteredDatasetProp, searchProp = 'name') {
  {
    return (searchText) => {
      this[filteredDatasetProp] = this[datasetProp].filter(
        (s) => s[searchProp] && s[searchProp].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
      );
    };
  }
}

export function compare(a, b) {
  let nameA = a.name.toLowerCase();
  let nameB = b.name.toLowerCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
}
export function quickTagsChange(seletedList, value) {
  return (this[seletedList] = value);
}
export function CheckUncheckAll(fG, FormArrayName = 'gridFields') {
  return (status) => {
    if (!status) {
      this[fG].get([FormArrayName]).reset();
    } else {
      (this[fG].controls[FormArrayName] as FormArray).controls.map((i) => {
        i.setValue(true);
      });
    }
  };
}

export function getCompanyNewsId(reportTypes) {
  let reportType = reportTypes.find((report) => report.name.toLowerCase().indexOf('news') >= 0);
  return reportType.id;
}
